import { createStyles, makeStyles } from '@material-ui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    showMoreLessBtn: {
      marginTop: theme.spacing(),
      padding: 0,
    },
  })
);

export default useStyles;
